import { render, staticRenderFns } from "./todo-column.vue?vue&type=template&id=5a3f0b5a&scoped=true&"
import script from "./todo-column.vue?vue&type=script&lang=js&"
export * from "./todo-column.vue?vue&type=script&lang=js&"
import style0 from "./todo-column.vue?vue&type=style&index=0&id=5a3f0b5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3f0b5a",
  null
  
)

export default component.exports